import { CalendarAvailability } from '@cue/calendars';
import { TimelineEvent, TimelineRoomGroup } from '../models';

const combineAvailabityBits = (bitA: CalendarAvailability, bitB: CalendarAvailability) => {
  return bitA === CalendarAvailability.free && bitB === CalendarAvailability.free
    ? CalendarAvailability.free
    : bitA > bitB
      ? bitA
      : bitB;
};

export const calculateCompatibleEvents = (roomgroups: TimelineRoomGroup[]) => {
  roomgroups.forEach((rg) => {
    rg.timelineSchedules.forEach((ts) => {
      const otherEventsGroups = roomgroups
        .filter((x) => x.requirement.id !== rg.requirement.id)
        .reduce((acc, group) => {
          acc.push({
            requirementId: group.requirement.id,
            timelineEvents: [],
          });
          return acc;
        }, []);
      ts.events = ts.events.map((e) => calculateCompatibleEventsForEvents(e, otherEventsGroups));
    });
  });

  return roomgroups;
};

export const calculateCompatibleEventsForEvents = (
  event: TimelineEvent,
  otherGroupEvents: { requirementId: string; timelineEvents: TimelineEvent[] }[]
) => {
  return event;
};
